const { default: axiosIns } = require('@/libs/axios')

const DisplayAdsService = {
  // GET - DisplayAdsApiController
  async getDisplayAds() {
    return axiosIns.get('admin/ads/display').then(response => response.data)
  },
  // PUT - DisplayAdsApiController
  async updateDisplayAds(model) {
    return axiosIns.put('admin/ads/display', model).then(response => response.data)
  },
}
export default DisplayAdsService
